export default __webpack_public_path__ + "static/media/endoso.68ed3713.svg";